import APIService from '@/services/APIService.js';

export default {
  getArquivosByAnoMesAndGrupoId(ano, mes, grupoId) {
    return APIService.apiCall().get(`/arquivosDados/getArquivosByAnoMesAndGrupoId?ano=${ano}&mes=${mes}&grupoId=${grupoId}`);
  },
  uploadFile(queryString, postData, config = {}) {
    return APIService.apiCall().post(
      `arquivosDados/upload?ano=${queryString.ano}&mes=${queryString.mes}&grupoId=${queryString.grupoId}`,
      postData,
      config
    );
  },
  setImportado(id) {
    return APIService.apiCall().get(`/arquivosDados/setImportado/${id}`);
  },
  excluir(id) {
    return APIService.apiCall().get(`/arquivosDados/excluir/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/arquivosDados/baixarArquivo/${id}`, { responseType: 'blob', ...config });
  }
};
